import React from 'react';
import './About.css';

const About = () => {
  const stats = [
    { number: '15+', label: 'Projects Delivered' },
    { number: '15+', label: 'Happy Clients' },
    { number: '12+', label: 'Expert Team' },
    { number: '5+', label: 'Years Experience' }
  ];

  const values = [
    {
      title: 'Innovation',
      description: 'We stay ahead of technology trends to deliver cutting-edge solutions.'
    },
    {
      title: 'Excellence',
      description: 'Quality is at the core of everything we do, ensuring exceptional results.'
    },
    {
      title: 'Reliability',
      description: 'Trusted partner for businesses seeking dependable technology solutions.'
    },
    {
      title: 'Collaboration',
      description: 'We work closely with clients to understand and exceed their expectations.'
    }
  ];

  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-text">
            <span className="section-tag">About Us</span>
            <h2 className="section-title">
              Building the <span className="highlight">Future</span> of Technology
            </h2>
            <p className="about-description">
              Assecure is a leading technology solutions provider, specializing in Web Development, Android Development, Cloud Solutions, Data Analytics, AI & Machine Learning, and Blockchain services. We combine innovation with expertise to deliver transformative digital solutions that drive business success.
            </p>
            <p className="about-description">
              Our team of skilled professionals is dedicated to helping businesses 
              navigate the digital landscape, providing scalable, secure, and 
              cutting-edge technology solutions tailored to your unique needs.
            </p>
          </div>

          <div className="about-stats">
            {stats.map((stat, index) => (
              <div 
                key={index} 
                className="stat-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="values-section">
          <h3 className="values-title">Our Core Values</h3>
          <div className="values-grid">
            {values.map((value, index) => (
              <div 
                key={index} 
                className="value-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="value-icon">
                  <div className="icon-circle"></div>
                </div>
                <h4 className="value-title">{value.title}</h4>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;


